import type { GmStatusKey } from '@/components/features/gamification/model/types/gm-statuses';
import type { GroupedPlayerRewardDto } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';
import type { ExtendedProgressStatusDto } from '@/queries/progress-statuses/progress-statuses.schema';
import { buildStatusRewardBenefits } from '@/components/features/gamification/model/utils/buildStatusRewardBenefits';

interface Params {
  currentStatusKey?: GmStatusKey;
  groupedRewards?: GroupedPlayerRewardDto[];
  progressStatuses?: ExtendedProgressStatusDto[];
  playerLevel: number;
}

export const buildGamificationRewardCards = (params: Params) => {
  const { currentStatusKey } = params;
  const benefits = buildStatusRewardBenefits({ ...params, view: 'rewards' });

  return benefits.map(({ benefit, availability, badges, groupedReward }) => {
    const isAvailable = availability === 'available';
    const subTitle = isAvailable && currentStatusKey ? benefit.values[currentStatusKey] : undefined;
    const availableAmount = isAvailable ? groupedReward?.availableAmount : 0;

    return {
      action: benefit.action,
      disabled: !isAvailable,
      reward: {
        subTitle,
        lockBadge: badges.rewardsGrid,
        type: benefit.type,
        availableAmount,
        rewardNotificationBadge: benefit.rewardNotificationBadge,
        title: benefit.translationKey,
        rewardImg: benefit.rewardImg,
        buttonLabelKey: benefit.buttonLabelKey,
      },
    };
  });
};
